export default class selectLang {

	static init() {

		$('.nav--dropdown').click(function () {
			$(".sub", this).toggleClass('open');
		});

	}

}
